import { render, staticRenderFns } from "./FmlFieldConfig.vue?vue&type=template&id=985029c6&"
import script from "./FmlFieldConfig.vue?vue&type=script&lang=js&"
export * from "./FmlFieldConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports